import { createContext, useContext } from "react";
import type { ControlSize } from "../types";
export interface ControlGroupContextValue {
  size: ControlSize;
}

export const ControlGroupContext =
  createContext<ControlGroupContextValue | null>(null);

export function useControlGroupContext() {
  return useContext(ControlGroupContext);
}

export function useControlGroupSize(size?: ControlSize) {
  const group = useControlGroupContext();
  return size ?? group?.size;
}
